import { MatchedFieldSummary } from '@core/Areas/Racing/Components/FieldSummary/MatchedFieldSummary'
import type { BettingInformation } from '../../../Model/BettingInformation'
import type ObservableRaceKey from '../../../Model/Observables/ObservableRaceKey'
import type ObservableTrotStarter from '../../../Model/Observables/ObservableTrotStarter'
import BaseStarterViewModel from './../BaseStarterViewModel'

export interface Params {
  data: ObservableTrotStarter
  raceNumber: ObservableRaceKey
  context: { bettingContext: BettingInformation }
  numberOfStartersInRace: ko.Computed<number>
  doubleProvDivAllowed: ko.Observable<boolean>
  quaddieProvDivAllowed: ko.Observable<boolean>
  isRaceClosed: ko.Observable<boolean>
}

export class TrotStarterViewModel extends BaseStarterViewModel {
  public MatchedFieldSummary = MatchedFieldSummary

  constructor(params: Params) {
    super(
      params.data,
      params.raceNumber,
      params.context.bettingContext,
      'Trots',
      params.numberOfStartersInRace,
      params.doubleProvDivAllowed,
      params.quaddieProvDivAllowed,
      params.isRaceClosed
    )
  }
}
